import ManageTests from './ManageTests'

export default ManageTests;